import { Directive, Input, TemplateRef, ViewContainerRef, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appHasPermission]'
})
export class HasPermissionDirective implements OnInit, OnDestroy {
  private permission: string = '';
  private context: string = ''; // NUEVO: Variable para almacenar el contexto (el ID del proyecto)
  private isHidden = true;
  private permissionSub!: Subscription;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService
  ) {}

  @Input()
  set appHasPermission(val: string) {
    this.permission = val;
    this.updateView();
  }

  // Angular usa esto para leer el parámetro "context: 'project:123'" del HTML
  @Input()
  set appHasPermissionContext(val: string) {
    this.context = val;
    this.updateView();
  }

  ngOnInit() {
    // Nos suscribimos para que reaccione en tiempo real si el JSON de permisos cambia
    this.permissionSub = this.authService.permissions$.subscribe(() => {
      this.updateView();
    });
  }

  private updateView() {
    if (!this.permission) return;
    // Evaluamos preguntándole al auth.service por el permiso Y el contexto exacto
    const hasPerm = this.authService.hasPermission(this.permission, this.context);

    if (hasPerm && this.isHidden) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.isHidden = false;
    } else if (!hasPerm && !this.isHidden) {
      this.viewContainer.clear();
      this.isHidden = true;
    }
  }

  ngOnDestroy() {
    if (this.permissionSub) {
      this.permissionSub.unsubscribe();
    }
  }
}